import React from "react";

const CityItemMedium = ({
	name,
	meta,
	extra = "",
}: {
	name: string;
	meta: string;
	extra?: string;
}) => (
	<div className={`item city medium ${extra}`}>
		<div className="itemImage">
			<div className="avatar city default" />
		</div>
		<div className="itemBody">
			<div className="title">{name}</div>
            <div className="meta">{meta}</div>
		</div>
	</div>
);

export default CityItemMedium;
